import gql from "graphql-tag"

const GET_PROOF_MEMORIZ_CANDLES_URl = gql`
  mutation GetProofMemorizCandlesUrl($orderID: ID!, $theme: String!) {
    getProofMemorizCandlesUrl(orderId: $orderID, theme: $theme)
  }
`

export default GET_PROOF_MEMORIZ_CANDLES_URl
